<template>
  <div>
    <div v-if="plans.init === 1">
      <v-layout row wrap class="mb-4">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" v-if="showAdjust" @click.prevent="promptReselect = true">
          Re-select Plan
          <v-icon right>mdi-pencil</v-icon>
        </v-btn>
      </v-layout>
      <transition name="slide-x-transition" mode="out-in">
        <package-plan-adj v-if="showAdjust" :plan="$store.getters.packageQuoteSelectedPlan" :limitsText="compileLimitsText" @proceed="doProceed"></package-plan-adj>
        <common-plans :plans="plans.plans" :limitsText="compileLimitsText" :selected="packageForm.planNo" :currPrefix="currPrefix" iconType="PACKAGE" @selectPlan="doSelectPlan" v-else></common-plans>
      </transition>
      <confirm v-model="promptReselect" @ok="doReselectPlan">
        Are you sure you want to re-select plan? Any plan adjustment will be discarded.
      </confirm>
      <v-layout row wrap class="mt-3">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row wrap class="mb-4">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
      <loader :height="425" :init="doInit" :errorMsgs="plans.initErr" loadText="Loading Plans..." errorText="Failed to load Plans" :loading="plans.init === 0"></loader>
      <v-layout row wrap class="mt-3">
        <v-btn round color="primary" @click.prevent="doBack">
          <v-icon left dark>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import clone from 'clone'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_PACKAGE_PLANS, QUOTE_PACKAGE_ADJ_CANCEL } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import CommonPlans from '../../shared/plans/CommonPlans'
import PackagePlanAdj from './PackagePlanAdj'

export default {
  data() {
    return {
      packageForm: {
        planNo: undefined
      },
      showAdjust: false,
      promptReselect: false
    }
  },
  computed: {
    plans() {
      return this.$store.state.agency.quotation.packageParam.plans
    },
    compileLimitsText() {
      // Need give the main row a main attribute (appearance tweak)
      const result = clone(this.plans.limitsText)
      for (const limit of result) {
        if (limit.value.indexOf('.') === -1) {
          limit.main = true
        }
      }
      return result
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    globalPackageForm() {
      return this.$store.state.agency.quotation.packageForm
    }
  },
  methods: {
    doInit() {
      if (this.plans.init !== 1) {
        this.$store.dispatch('packageQuotePlans')
      }
      this.packageForm.planNo = this.globalPackageForm.planNo
      if (this.packageForm.planNo) {
        this.showAdjust = true
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'packageQuote' })
    },
    doSelectPlan(obj) {
      if (obj) {
        this.packageForm.planNo = obj.value
        if (obj.proceed) {
          this.$store.commit(QUOTE_PACKAGE_PLANS, this.packageForm.planNo)
          this.showAdjust = true
        }
      }
    },
    doReselectPlan() {
      this.showAdjust = false
      this.promptReselect = false
      this.$store.commit(QUOTE_PACKAGE_ADJ_CANCEL)
      this.packageForm.planNo = null
    },
    doProceed() {
      if (this.packageForm.planNo) {
        this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
        this.$router.push({ name: 'packageQuoteApplicant' })
      } else {
        this.$snotify.error('Please select a Plan')
      }
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        // Do not commit planNo here (if not adjustment will reset)
        // this.$store.commit(QUOTE_PACKAGE_PLANS, this.packageForm.planNo)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
    this.doInit()
  },
  components: {
    CommonPlans,
    PackagePlanAdj
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style>
</style>
